import { useMemo } from "react"
import { PoolName } from "../constants/pools/types/PoolName"

export function useMemoizePoolNameAsArray(name: PoolName): PoolName[] {
  return useMemo(() => {
    return [name]
  }, [name])
}
